import React, { useState } from "react";
import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import { KeyboardArrowDown, ViewComfy } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: "8px 12px",
}));

const ReportDropdown = ({ onGenericReport, onWeeklyActivityReport }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleGenericReport = () => {
    setOpen(false);
    onGenericReport();
  };

  const handleWeeklyActivityReport = () => {
    console.log("Weekly Activity Report clicked in dropdown");
    setOpen(false);
    onWeeklyActivityReport();
  };

  return (
    <>
      <StyledButton
        ref={anchorRef}
        aria-controls={open ? "report-menu" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        color="info"
        startIcon={<ViewComfy />}
        endIcon={<KeyboardArrowDown />}
      >
        Reports
      </StyledButton>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ zIndex: 1300 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="report-menu" aria-labelledby="report-button">
                  <MenuItem onClick={handleGenericReport}>Generic Report</MenuItem>
                  <MenuItem onClick={handleWeeklyActivityReport}>Weekly Activity Report</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default ReportDropdown;
